/**
 * EnlargeButtonsFeature - Make buttons and interactive elements larger
 */
import BaseFeature from './BaseFeature.js';

export default class EnlargeButtonsFeature extends BaseFeature {
    enable() {
        super.enable();
        this.addBodyClass('dhA11y-enlarge-buttons');
    }

    disable() {
        super.disable();
        this.removeBodyClass('dhA11y-enlarge-buttons');
    }
}
